/**Dependencies */
import React, { useState } from "react";

/**Components */
import Accordion from "react-bootstrap/Accordion";
import { Row, Col } from "react-bootstrap";

/**Styles */
import "../styles/components/politicas.scss";

/**Images */

export const PreguntaFrecuentes = () => {
  const [activeKey, setActiveKey] = useState(null);
  const faqData = [
    {
      pregunta: "¿Qué es AGENCIA MARZAH?",
      respuesta: `
            <p style="text-align: justify;">
                <strong>AGENCIA MARZAH</strong> es tú agente de viajes de confianza. Nos enfocamos en brindar servicios de turismo entre otras actividades relacionadas a todo tipo de viajes; personales, grupales, empresariales, etc. Constituida legalmente en el marco de las reglamentaciones mexicanas con dirección fiscal en <strong>Cancún, Q. Roo México.</strong>.
            </p>
        `,
    },
    {
      pregunta: "¿Cómo pueden encontrarnos? ",
      respuesta: `
            <p style="text-align: justify;">
                Para tu mayor comodidad, hacemos reservaciones vía telefónica y de manera online, garantizándote siempre un trato personalizado y atento. Nuestras oficinas están ubicadas en <strong>Cancún, Q. Roo México.</strong> en donde podemos recibirte con gusto previa cita. Contactanos al correo <strong>administracion@marzahtravel.com</strong> o al teléfono <strong>998 218 9740</strong>
            </p>
        `,
    },
    {
      pregunta: "¿Por qué reservar con nosotros? ",
      respuesta: `
            <p style="text-align: justify;">
                Confianza, Atención y Seguridad. 
                Somos una marca registrada y con todos los Derechos Reservados. Puedes acceder a nuestro RFC, en caso de que así lo desees.
                Contamos con Registro Nacional de Turismo <strong>(RNT) No. 04230051273</strong>. Lo que avala que estamos inscritos legalmente ante la Secretaría de Turismo. Lo puedes verificar directamente en su portal oficial bajo nuestro nombre comercial: <strong>AGENCIA MARZAH</strong>.
                Nuestra página de Facebook cuenta con registro y certificación de la empresa.
                En cada compra, te otorgamos un número de confirmación, que se puede verificar con el hotel casi inmediatamente.
                En todas las operaciones con tarjeta de crédito se genera automáticamente un folio que llega a tu teléfono o correo electrónico, donde tú como cliente podrás autorizar de manera inmediata la compra realizada. 
                Nuestros contratos son directos con empresas hoteleras, de tours y transportación, lo que avala nuestra seriedad y buen desempeño.
                Estamos comprometidos con el turismo, trabajamos siempre para brindarte un servicio excepcional, en los mejores destinos y a precios exclusivos.
            </p>
        `,
    },
    {
      pregunta: "¿Qué necesito para reservar?",
      respuesta: `
            <p style="text-align: justify;">
                ¡Reservar con nosotros es muy fácil! <br/>
                Solamente necesitas:<br/>
                Llenar el formulario que se encuentra en la sección de contacto, e indicar el horario en el que prefieres que te contactemos <strong>(Lunes a Viernes de 9:00 am a 6:00 pm y Sábados de 9:00 am a 4:00 pm)</strong>. Si tienes algún destino en mente, así como los días para viajar, inclúyelos en tu mensaje.
                Nosotros nos comunicaremos contigo a la brevedad. Se te serán solicitados los datos para levantar la reserva y así realizar el cargo correspondiente a tu compra.
                Aceptamos todos los métodos de pago: TDC/ TDD, depósito en ventanilla o transferencia electrónica.  
                Recibirás la confirmación de tu reserva a través de tu correo electrónico.
                Si tienes alguna pregunta adicional, puedes comunicarte al <strong>9982 18 97 40</strong> y con gusto te atenderemos.  
            </p>
        `,
    },
    {
      pregunta: "¿Es necesario pagar con tarjetas de crédito?",
      respuesta: `
            <p style="text-align: justify;">
                <strong>AGENCIA MARZAH</strong> acepta desde transferencias y depósitos bancarios. Por otra parte, es importante saber que, al realizar el pago con tarjeta de crédito, puedes obtener grandes beneficios como promociones accesibles y atractivas para tus próximas vacaciones.
            </p>
        `,
    },
    {
      pregunta: "Mi asesor no se comunicó conmigo, ¿Qué hago?",
      respuesta: `
            <p style="text-align: justify;">
                Esto puede deberse a la alta demanda de llamadas que mantenemos durante el día. Si ya pasaron más de 24 hrs desde el envío de tu formulario, puedes comunicarte al <strong>9982 18 97 40</strong> teniendo siempre a la mano nombre y apellido bajo el cual se haya realizado el registro. Uno de nuestros ejecutivos te atenderá a la brevedad.
            </p>
        `,
    },
    {
      pregunta: "¿Puedo apartar un paquete y pagarlo después?",
      respuesta: `
            <p style="text-align: justify;">
                ¡Por supuesto! Únicamente solicita a tu asesor de ventas las formas posibles de pago con las que contamos para poder apartar y concretar tu promoción en el periodo establecido, o bien, reservar con un anticipo. 
            </p>
        `,
    },
    {
      pregunta: "¿Puedo comprar vuelos con ustedes?",
      respuesta: `
            <p style="text-align: justify;">
                ¡Sí, obtener tu vuelo con nosotros es posible! gracias a que tenemos convenio con todas las líneas aéreas a nivel mundial.
            </p>
        `,
    },
    {
      pregunta: "Si ya compré mi reserva, ¿Puedo cambiar las fechas?",
      respuesta: `
            <p style="text-align: justify;">
                ¡Claro! Siempre apegados a la restricción de la tarifa que se haya adquirido, por lo que es importante leer las políticas de cambios y cancelaciones que se te hacen llegar al momento de realizar tu compra de vuelo, hotel, crucero, tour o circuito.
            </p>
        `,
    },
    {
      pregunta: "¿Qué pasa si quiero cancelar?",
      respuesta: `
            <p style="text-align: justify;">
                La mayoría de nuestros paquetes no son reembolsables. En caso de que no puedas viajar, te podremos ayudar a gestionar un cambio de fechas sujeto a variaciones de precio y disponibilidad. En caso de que tu paquete sea reembolsable, puedes consultar las condiciones de reembolso y penalidades en el apartado Condiciones del Servicio, disponibles en nuestros Términos y condiciones, o llamar a nuestro centro de reservas. <br/>
                Número de teléfono para atención al cliente: <strong>9982 18 97 40</strong><br/>
                Horarios y días de atención: <strong>Lunes a Viernes de 9:00 am a 6:00 pm y Sábados de 9:00 am a 4:00 pm.</strong><br/>
                Dirección: <strong>Cancún, Q. Roo México.</strong><br/>
                Razón social: <strong>TUCANCUN MARZAH SAS DE CV</strong> 
            </p>
        `,
    },
  ];
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  return (
    <div className="py-5">
      <div className="accordion-faqs container py-5 border-top border-black">
        <Row>
          <Col lg={12}>
            <div className="centered-mobile mb-4">
              <div className="w-100 d-grid justify-content-center">
                <h1
                  className="text-lg-start text-center title-home destinos-inigualables-pf mb-4"
                  style={{ fontWeight: "700", letterSpacing: "3px" }}
                >
                  Preguntas Frecuentes
                </h1>
                <h3
                  className="text-start title-home d-none d-lg-flex fw-normal mejores-destinos"
                  style={{ width: "auto", fontSize: "20px" }}
                >
                  Respuestas a tus inquietudes sobre destinos, servicios,
                  políticas de cancelación y reservas. Asegura que cada detalle
                  esté cubierto para disfrutar al máximo de la experiencia.
                </h3>
              </div>
            </div>
          </Col>
          <Col lg={12}>
            <Accordion activeKey={activeKey} className="accordion-faqs">
              {faqData.map((item, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header
                    onClick={() => handleToggle(index.toString())}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>{item.pregunta}</span>
                    <span style={{ marginLeft: "auto" }}>
                      {activeKey === index.toString() ? "-" : "+"}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div dangerouslySetInnerHTML={{ __html: item.respuesta }} />
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </div>
    </div>
  );
};
